import { motion } from "motion/react";
import { useCallback, useEffect, useMemo } from "react";
import { useStrokeContext } from "../../services/editor/editorContext";
import style from './ColorPicker.module.css';
import { PublicColorKey } from "../../services/editor/ColorPalette";


export const ColorButton: React.FC<{
    colorKey: PublicColorKey,
    cssVal: string;
}> = ({ colorKey, cssVal }) => {

    const { setColor, color } = useStrokeContext();

    const handleClick = useCallback(() => {
        setColor(colorKey);
    }, [setColor, colorKey]);

    const css = useMemo(() => {

        const value: React.CSSProperties = {
            backgroundColor: cssVal as string,
            border: "var(--border-width) solid var(--bg)"
        }

        if (color === colorKey) {
            value.outline = " var(--border-width) solid  var(--text)";
        }

        return value;

    }, [colorKey, cssVal, color]);

    return <button
        className={style.color}
        style={css}
        onClick={() => handleClick()}
    ></button>

}

export const ColorPicker: React.FC = () => {

    const { availableColors, finished, color } = useStrokeContext();

    const borderColor = useMemo(() => {

        if (finished && color === undefined) {
            return "var(--text)";
        }

        return "var(--gray)";

    }, [finished, color]);

    useEffect(() => {
        if (finished) {
            // addMessage( "Zvolte barvu", false, 5000 );
        }
    }, [finished]);

    const entries = useMemo( () => {
        return Object.entries( availableColors );
    }, [availableColors] );

    if (!finished) {
        return <></>;
    }

    return <motion.div
        className={style.container}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        style={{ borderColor: borderColor }}
    >

        {entries?.map(([key, cssVal]) => <ColorButton key={key} colorKey={key as PublicColorKey} cssVal={cssVal} />)}
    </motion.div>

}